export default "__VITE_ASSET__BKaegeOv__"